import axios from "axios";
const APIKEY = "PQ6Ti2RSLi9r3smxYWt5B7ELyRsp7k8r9VL8a2Nd";
const HEADERS = {
  "X-API-Key": APIKEY,
};

const state = {};

const getters = {};

const actions = {
  async addFormRequest(context, reqParams) {
    var response = await axios({
      method: "post",
      url: `https://bvbubh4sqf.execute-api.us-west-2.amazonaws.com/prod/form-request?event_type=${reqParams.event_type}`,
      headers: HEADERS,
      data: reqParams.data,
    });
    return response;
  },

  async getFormRequest(context, reqParams) {
    var response = await axios({
      method: "get",
      url: `https://bvbubh4sqf.execute-api.us-west-2.amazonaws.com/prod/form-request?event_type=${reqParams.event_type}&id=${reqParams.id}`,
      headers: HEADERS,
    });
    return response;
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
